import { faMinus, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef } from "react";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import Table from "../../../../../Components/Table";
import {
    AtualizarAtributoController,
    DesvincularAtributoEtapaTipoCasoController,
    ListarAtributosVinculadosPorEtapaTipoCasoController,
} from "../../../../../Controllers/Geral/AtributosEtapa/AtributosEtapaController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { IListarAtributosPorEtapaTipoCaso } from "../../../../../Interfaces/Geral/AtributosEtapa/AtributosEtapaInterface";

import "./styles.css";

interface IAtributosEtapaVinculadasProps {
    idEtapa: number;
    idTipoCaso: number;
}

export default function AtributosEtapaVinculadas(
    props: IAtributosEtapaVinculadasProps
) {
    const {
        value: atributosVinculadosPorEtapa,
        loading: atributosVinculadosPorEtapaLoading,
        execute: updateList,
    } = useAsyncEffect(() =>
        ListarAtributosVinculadosPorEtapaTipoCasoController(
            props.idTipoCaso,
            props.idEtapa
        )
    );

    const { execute: atualizarAtributo } = useAsyncCallback(
        AtualizarAtributoController
    );

    const {
        execute: desvincularAtributo,
        loading: desvincularAtributoLoading,
    } = useAsyncCallback(DesvincularAtributoEtapaTipoCasoController);

    const lstSelecionados = useRef<Array<IListarAtributosPorEtapaTipoCaso>>([]);

    function handleDesvincularAtributoUnico(
        row: IListarAtributosPorEtapaTipoCaso
    ) {
        desvincularAtributo([row.ID_ATRIBUTO_ETAPA_TIPO_CASO]).then(() => {
            updateList();
        });
    }

    function handleDesvincularTodosAtributos() {
        desvincularAtributo(
            lstSelecionados.current.map(
                (selecionados) => selecionados.ID_ATRIBUTO_ETAPA_TIPO_CASO
            )
        ).then(() => {
            updateList();
        });
    }

    function handleAtualizarAtributo(row: IListarAtributosPorEtapaTipoCaso) {
        atualizarAtributo({
            ID_ATRIBUTO: row.ID_ATRIBUTO,
            FL_OBRIGATORIO: !row.FL_OBRIGATORIO,
            ID_ATRIBUTO_ETAPA_TIPO_CASO: row.ID_ATRIBUTO_ETAPA_TIPO_CASO,
        }).then(() => updateList());
    }

    function handleAtualizarDataFutura(row: IListarAtributosPorEtapaTipoCaso) {
        atualizarAtributo({
            ID_ATRIBUTO: row.ID_ATRIBUTO,
            FL_NAO_PERMITE_DATA_FUTURA: !row.FL_NAO_PERMITE_DATA_FUTURA,
            ID_ATRIBUTO_ETAPA_TIPO_CASO: row.ID_ATRIBUTO_ETAPA_TIPO_CASO,
        }).then(() => updateList());
    }

    const selectRowProp: SelectRowProps<IListarAtributosPorEtapaTipoCaso> = {
        mode: "checkbox",
        clickToSelect: true,
        selected: lstSelecionados.current.map((p) => p.ID_ATRIBUTO),

        onSelect: (row, isSelect) => {
            row.FL_MARC = isSelect;
            const lstAtributosMarcados =
                atributosVinculadosPorEtapa?.filter((p) => p.FL_MARC) ?? [];

            lstSelecionados.current = lstAtributosMarcados;
        },

        onSelectAll: (
            isSelect,
            rows: Array<IListarAtributosPorEtapaTipoCaso>
        ) => {
            rows.forEach((row) => {
                row.FL_MARC = isSelect;
            });

            lstSelecionados.current =
                atributosVinculadosPorEtapa?.filter((p) => p.FL_MARC) ?? [];
        },
    };

    const tableviewColumns: Array<
        ColumnDescription<IListarAtributosPorEtapaTipoCaso>
    > = [
        {
            dataField: "DS_DESCRICAO",
            text: "",
            formatter: (c, row) => (
                <div className="d-flex flex-md-nowrap flex-wrap justify-content-between p-3 align-items-center">
                    <div>
                        <h6>{c}</h6>
                    </div>
                    <div className="Button-Tools">
                        {row.DS_ATRIBUTO.includes("DT_") ? (
                            <>
                                {row.FL_NAO_PERMITE_DATA_FUTURA ? (
                                    <button
                                        className="btn btn-outline-warning font-weight-bold mr-2 "
                                        onClick={() =>
                                            handleAtualizarDataFutura(row)
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            size="lg"
                                        />
                                        <span className="d-none d-sm-block">
                                            Permitir Data Futura
                                        </span>
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-outline-success font-weight-bold mr-2 "
                                        onClick={() =>
                                            handleAtualizarDataFutura(row)
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={faMinus}
                                            size="lg"
                                        />
                                        <span className="d-none d-sm-block">
                                            Não Permitir Data Futura
                                        </span>
                                    </button>
                                )}
                            </>
                        ) : (
                            <></>
                        )}
                        {row.FL_OBRIGATORIO ? (
                            <button
                                className="btn btn-outline-primary font-weight-bold mr-2 "
                                onClick={() => handleAtualizarAtributo(row)}
                            >
                                <FontAwesomeIcon icon={faCheck} size="lg" />{" "}
                                <span className="d-none d-sm-block">
                                    Obrigatório
                                </span>
                            </button>
                        ) : (
                            <button
                                className="btn btn-outline-primary font-weight-bold mr-2 "
                                onClick={() => handleAtualizarAtributo(row)}
                            >
                                <FontAwesomeIcon icon={faCheck} size="lg" />{" "}
                                <span className="d-none d-sm-block">
                                    Não Obrigatório
                                </span>
                            </button>
                        )}

                        <button
                            className="btn btn-outline-danger font-weight-bold mr-2 "
                            disabled={desvincularAtributoLoading}
                            onClick={() => handleDesvincularAtributoUnico(row)}
                        >
                            {desvincularAtributoLoading ? (
                                <Spinner />
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faMinus} size="lg" />{" "}
                                    <span className="d-none d-sm-block">
                                        Desvincular
                                    </span>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className="d-flex col-12 justify-content-end mb-3">
                <button
                    className="btn btn-primary"
                    onClick={() => handleDesvincularTodosAtributos()}
                >
                    Desvincular Selecionados
                </button>
            </div>
            <Table
                wrapperClasses="mw-100 custom-scroll"
                columns={tableviewColumns}
                data={atributosVinculadosPorEtapa ?? []}
                selectRow={selectRowProp}
                loading={atributosVinculadosPorEtapaLoading}
                keyField="ID_ATRIBUTO"
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Atributo Encontrado
                    </div>
                )}
                noHover
                bordered={false}
                striped={true}
                rowClasses={"rowClasses"}
                center={true}
            />
        </div>
    );
}
